export default __webpack_public_path__ + "static/media/Magical-MP.8a93d324.jpg";